import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PublicNotFound from "../scenes/notFoundPages/PublicNotFound";
import { isSessionValidForRoles } from "../utils/tokenGuard";
import { purgeLegacyJwtFromStorage } from "../utils/authSession";

export default function PublicRouteGuard({ children }) {
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const location = useLocation();

  const hasValidDoctorAccess = isSessionValidForRoles(["doctor", "admin"]);
  const hasValidTenantAccess = isSessionValidForRoles(["tenant"]);
  const hasValidSuperAdminAccess = isSessionValidForRoles(["super_admin"]);

  useEffect(() => {
    purgeLegacyJwtFromStorage();
  }, []);

  // Hiçbir geçerli (süresi dolmamış + doğru rollü) token yoksa PublicNotFound göster
  if (!hasValidDoctorAccess && !hasValidTenantAccess && !hasValidSuperAdminAccess) {
    return <PublicNotFound />;
  }

  // Token varsa, korumalı içeriği göster
  return children;
}
